import React, { Suspense, useCallback } from "react";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { GetCelebration } from "./Celebration-Service/CelebrationService";
import { TostMsg } from "../../../App";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import InfiniteScroll from "react-infinite-scroll-component";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
export default function Celebrations() {
  const MAX_LENGTH = 250;
  const [celebrationList, setCelebrationList] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const toster = useContext(TostMsg);
  const [IsLoading, setIsLoading] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState(0);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [noData, setNoData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [showCelebrationNotFound, setShowCelebrationNotFound] = useState(false);

  useEffect(() => {
    getMasterCelebration();
    GetMasterSystemAlertList("celebration_header", 1);
    GetMasterSystemAlertList("No_Celebration", 2);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getCelebration([]);
    setPage(1);
    setHasMore(true);
  }, [selectedRadio]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  async function getCelebration() {
    setIsLoading(true);
    const params = {
      OrgId: userDetails.OrgId,
      KeyId: Number(selectedRadio),
      PageNumber: page,
      PageSize: 24,
    };
    try {
      let data = await GetCelebration(params);
      let CelebrationListData = data?.data?.Data || [];
      setIsLoading(false);
      if (CelebrationListData?.length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
        setCelebrationList((data) => [...data, ...CelebrationListData]);
        setPage((p) => p + 1);
      }
    } catch (error) {
      setIsLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const getMasterCelebration = async () => {
    let params = {
      masterType: "CelebrationType",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };

    try {
      let responce = await GetMasterTypeData(params);
      let CelebrationLst = responce?.Data?.toSpliced(0, 0, {
        Id: 0,
        Name: "All Celebrations",
      });
      setMasterData(CelebrationLst);
      if (CelebrationLst?.length === 0) {
        setHasMore(false);
        setShowCelebrationNotFound(true);
      }
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  };

  function occassionDefaultImages(CelebrationId) {
    return (
      <div>
        {CelebrationId === 3 ? (
          <img src="images/org-img/awards/birthday.png" />
        ) : CelebrationId === 2 ? (
          <img src="images/org-img/awards/wedding.png" />
        ) : CelebrationId === 1 ? (
          <img src="images/org-img/awards/work.png" />
        ) : (
          <img src="images/org-img/awards/work.png" />
        )}
      </div>
    );
  }

  function noDataImages(CelebrationId) {
    return (
      <div>
        {CelebrationId == "3" ? (
          <img src="images/no-data-found/Birthday.png" />
        ) : CelebrationId == "2" ? (
          <img src="images/no-data-found/Anniversary.png" />
        ) : CelebrationId == "1" ? (
          <img src="images/no-data-found/work_anniversary.png" />
        ) : (
          <img src="images/no-data-found/celibration.png" />
        )}
      </div>
    );
  }

  const handleRadioChange = useCallback((event) => {
    if (event.target.value) {
      setSelectedRadio(event.target.value);
      setCelebrationList([]);
      setPage(1);
    }
  }, []);

  return (
    <div className="position-relation">
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row g-4">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Team Moments</h2>
              <p className="text-light">{masterSystemAlertData}</p>
            </div>
            <div className="rightside-tabs mb-0">
              <div className="org-cate">
                <div className="choose-celebration">
                  {masterData?.map((filterName, index) => (
                    <div key={index} className="flex align-items-center">
                      {/* <RadioButton inputId={filterName?.id} name="radioGroup" value={filterName?.id} onChange={() => handleRadioChange(filterName)} checked={selectedRadio == filterName?.id || filterName?.id == 0} /> */}
                      <input
                        type="radio"
                        id={filterName?.Id}
                        name="radioGroup"
                        value={filterName?.Id}
                        checked={selectedRadio == filterName?.Id}
                        onChange={handleRadioChange}
                      />
                      <label htmlFor={filterName?.Id}>{filterName?.Name}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <InfiniteScroll
              dataLength={celebrationList?.length}
              next={() => setTimeout(() => getCelebration(), 700)}
              hasMore={page > 1 && hasMore}
              scrollableTarget="scrollableDiv"
              style={{ overflow: "hidden" }}
            >
              <div className="row g-3">
                {celebrationList?.map((occassion, index) => (
                  <div className="col-xl-4" key={index}>
                    <div className="card mb-0">
                      <div className="card-body mb-0">
                        <div className="row">
                          <div className="">
                            <div className="whose-celebration">
                              <div className="name">
                                <span>{occassion?.CelebrationType}</span>
                                <Link to={`/Profile/${occassion.GUID}`}>
                                  <h5 className="card-title d-flex align-items-center mt-1 mb-2">
                                    <LazyImage
                                      src={occassion?.ProfileImage}
                                      className="w-20"
                                      style={{ width: "20%" }}
                                    />
                                    {occassion?.Name}
                                  </h5>
                                </Link>
                                {occassion?.Comment ? (
                                  <ul>
                                    <li>
                                      {occassion.Comment.length > MAX_LENGTH
                                        ? `${occassion.Comment.slice(
                                            0,
                                            MAX_LENGTH
                                          )}..`
                                        : occassion.Comment}
                                    </li>
                                  </ul>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="img">
                                {occassionDefaultImages(
                                  occassion?.CelebrationTypeId
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer awards-div-list2">
                        <strong className="announced-by">
                          <p>
                            <img src="/images/policy/date.svg" />
                            {occassion?.CelebratedOn}
                          </p>
                        </strong>
                      </div>
                    </div>
                  </div>
                ))}
                {celebrationList.length == 0 || celebrationList == null ? (
                  <div className="notfound">
                    {noDataImages(selectedRadio)}
                    <p>{noData}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>
      {IsLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
